import _ from 'lodash';
import { Component, DestroyRef, ElementRef, inject, Input, OnInit, ViewChild } from '@angular/core';
import { ModalP2pAddDonationsService } from '../../services/modal-p2p-add-donations/modal-p2p-add-donations.service';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { addP2PDonation } from '../../features/p2p.actions';
import { SharedService } from 'app/virtual-event/services/shared.service';
import { ModalStreetAddressService } from '../../services/modal-street-address/modal-street-address.service';
import { DonorService } from 'app/core/services/donor.service';
import { MdbSelectModule } from 'mdb-angular-ui-kit/select';
import { CoreModule } from 'app/core/core.module';
import { MdbAutocompleteModule } from 'mdb-angular-ui-kit/autocomplete';
import { CommonModule } from '@angular/common';
import { GoogleMapsAutocompleteModule } from 'app/google-maps-autocomplete/google-maps-autocomplete.module';
import { NgxCurrencyDirective } from 'ngx-currency';
import { MdbInputGoogleMapsAutocompleteComponent } from 'app/core/components/mdb-input-google-maps-autocomplete/mdb-input-google-maps-autocomplete.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { EmailNameSpliterService } from 'app/core/services/email-name-spliter.service';

@Component({
  standalone:true,
  selector: 'app-p2p-add-donations-modal',
  templateUrl: './p2p-add-donations-modal.component.html',
  styleUrls: ['./p2p-add-donations-modal.component.scss'],
  imports:[FormsModule,ReactiveFormsModule,MdbSelectModule,CoreModule,CommonModule,MdbAutocompleteModule,GoogleMapsAutocompleteModule, NgxCurrencyDirective, MdbInputGoogleMapsAutocompleteComponent]
})
export class P2pAddDonationsModalComponent implements OnInit {
  destroyRef = inject(DestroyRef)
  @Input () data

  @ViewChild('addMemoP2P', { static: true }) addMemoP2PCheckbox!: ElementRef<HTMLInputElement>;
  @ViewChild('dateInput', { static: false }) dateInput!: ElementRef;
  @ViewChild('p2pAddressField', {static: true}) field: ElementRef;

  
  public addP2pDonationForm: UntypedFormGroup;
  public isModalOpen = false;
  
  public campaignData: any = null;
  public campaignTypeData: any = null;
  public userData: any = null;

  public P2PItemId: any = null;
  public userId: any = null;

  public donateOptions = [{
    id: 0,
    label: 'Check'
  }, {
    id: 1,
    label: 'Cash'
  }, {
    id: 2,
    label: 'Other'
  }];

  public searchResult = [];
  private allProfiles = null;

  public notFound = false;

  public searchedUserData = null;
  public searchedName ='';
  public searchedEmail = '';

  public dateInputValue = null;

  public streetAddressRequired: boolean = false;
  public phoneNumRequired: boolean = false;
  public additionalInfoRequired: boolean = false;
  public additionalInfoSelectRequired: boolean = false;

  public isNamelInputLabelActive: boolean = false;
  public isemailLabelActive: boolean = false;
  public isMemoInputLabelActive: boolean = false;
  public showMemo: boolean = false;

  public showNameError = false
  public showEmailError = false;
  public showAmountError = false;
  
  public isAddActive = false;

  public name: any = null;
  public email: any = null;
  public amount: any = null;
  public addressInput: any = null;
  public addressUnit: any = null;
  public phone: any = null;
  public addInfo: any = null;
  public addInfoSelect: any = null;
  public memoInput: any = null;

  public address: string = null;
  public isUnitLabelActive: boolean = false;

  constructor(
    private modalP2pAddDonationsService: ModalP2pAddDonationsService,
    private formBuilder: UntypedFormBuilder,
    private store: Store,
    public sharedService: SharedService,
    private modalStreetAddressService: ModalStreetAddressService,
    private donorService: DonorService,
    private emailNameSpliter: EmailNameSpliterService,
    ) { }

  ngOnInit(): void {
    const { id, campaignData, campaignData: { campaignTypeData } } = this.data;
    this.P2PItemId = id;
    this.campaignData = campaignData;
    this.campaignTypeData = campaignTypeData;

    const {additionalInfoRequired, additionalInfoSelectRequired, phoneNumRequired, streetAddressRequired } = this.campaignTypeData;

    this.streetAddressRequired = streetAddressRequired;
    this.phoneNumRequired = phoneNumRequired;
    this.additionalInfoRequired = additionalInfoRequired;
    this.additionalInfoSelectRequired = additionalInfoSelectRequired;
    
    this.addP2pDonationForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.pattern(/^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/)]],
      amount: ['', Validators.required],
      paymentMethod: ['', Validators.required],
      addressInput: [''],
      addressUnit: [''],
      phone: [''],
      addInfo: [''],
      addInfoSelect: [''],
      memoInput: [''],
    });

    this.name = this.addP2pDonationForm.get('name')
    this.email = this.addP2pDonationForm.get('email')
    this.amount = this.addP2pDonationForm.get('amount')
    this.addressInput = this.addP2pDonationForm.get('addressInput')
    this.addressUnit = this.addP2pDonationForm.get('addressUnit')
    this.phone = this.addP2pDonationForm.get('phone')
    this.addInfo = this.addP2pDonationForm.get('addInfo')
    this.addInfoSelect = this.addP2pDonationForm.get('addInfoSelect')
    this.memoInput = this.addP2pDonationForm.get('memoInput')

    if(this.streetAddressRequired) {
      this.addressInput.setValidators([Validators.required]);
    }
    if(this.phoneNumRequired) {
      this.phone.setValidators([Validators.required]);
    }
    if(this.additionalInfoRequired) {
      this.addInfo.setValidators([Validators.required]);
    }
    if(this.additionalInfoSelectRequired) {
      this.addInfoSelect.setValidators([Validators.required]);
    }

    this.amount.valueChanges.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(()=>{
      this.amount.setErrors(null)
    })

    this.phone.valueChanges.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(()=>{
      this.phone.setErrors(null)
    })
  }

  addDonation() {
    if(this.addP2pDonationForm.status === 'INVALID') {
      this.addP2pDonationForm.markAllAsTouched();
      return false
    }

    if(this.amount.value < 1) {
      this.addP2pDonationForm.get('amount').setErrors({'incorrect': true})
      return false;
    }

    let numberStr = this.phone.value;
    let digitCount = (numberStr.match(/\d/g) || []).length;
  
    if(numberStr !== '' && digitCount < 11){
      this.addP2pDonationForm.get('phone').setErrors({'incorrect': true})
      return false;
    }

    let params = {
      peerToPeerId: this.P2PItemId,
      amount: this.amount.value,
      paymentMethod: this.addP2pDonationForm.get('paymentMethod').value,
    }

    if (this.userId !== null && (this.name.value === this.searchedName || this.email.value === this.searchedEmail)) {
      params['userId'] = this.userId;
    } else {
      params['name'] = this.name.value;
      params['email'] = this.email.value;
    }

    const selectedDate = this.dateInput.nativeElement.value
    if(selectedDate == '') {
      const currentDate = new Date();
      const currentDateUnix = Math.floor(currentDate.getTime() / 1000);
      params['donationDate'] = currentDateUnix;
    } else {
      params['donationDate'] = this.convertDateToUnixTimestamp(selectedDate);
    }

    if(this.streetAddressRequired) {
      params['streetAddress'] = this.addressInput.value;
    }
    if(this.phoneNumRequired) {
      params['phone'] = this.phone.value;
    }
    if(this.additionalInfoRequired) {
      params['additionalInfo'] = this.addInfo.value;
    }
    if(this.additionalInfoSelectRequired) {
      params['additionalInfoSelected'] = this.addInfoSelect.value;
    }
    if(this.memoInput.value != '') {
      params['memo'] = this.memoInput.value;
    }

    this.store.dispatch({
      type: addP2PDonation.type,
      payload:  {
        params: params,
        id: this.data.campaignId
      }
    });

    this.close()
  }

  onInputFocus() {
    this.showNameError = false;
    this.showEmailError = false;
    this.showAmountError = false;
  }

  passOption(event: MouseEvent | KeyboardEvent){
    let searchString;
    if (event instanceof MouseEvent) {
      searchString = (event.target as HTMLElement).innerText;
    } else if (event instanceof KeyboardEvent && event.target instanceof HTMLInputElement) {
      searchString = event.target.value;
    }

    const [name, email] = this.emailNameSpliter.getNameAndEmail(searchString, true);

    this.name.setValue('');
    this.email.setValue('');

    this.isNamelInputLabelActive = false;
    this.isemailLabelActive = false;

    this.name.setValue(name);
    this.email.setValue(email);

    this.isNamelInputLabelActive = !!this.name.value;
    this.isemailLabelActive = !!this.email.value;

    this.searchedUserData = this.userData.filter((item)=>
      item.name.toLowerCase().includes(name.toLowerCase()) &&
      item.email.toLowerCase().includes(email.toLowerCase())
    );

    this.userId = this.searchedUserData[0].id;
    this.searchedName = this.searchedUserData[0].name;
    this.searchedEmail = this.searchedUserData[0].email;
  }

  searchDonor(value, name) {
    if(value.length > 1) {
      this.donorService.search(value, name)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((userProfiles) => {
          this.allProfiles = userProfiles;
          this.search(value)
      });
    }
  }

  search(searchValue) {

    let profileInfo = this.allProfiles.usersProfile.map(data => ({
      "data": data,
      "searchString": data.name + "/" + data.email
    }));

    this.userData = profileInfo.map(item => item.data);

    let filteredResult = profileInfo.filter((item)=>item.searchString.toLowerCase().includes(searchValue))

    if(filteredResult.length === 0)
      this.notFound = true
    else
      this.notFound = false;
      
    this.searchResult = filteredResult;
  }

  convertDateToUnixTimestamp(dateInputValue) {
    if(!dateInputValue) {
      return 0
    }

    let [day, month, year] = dateInputValue.split(' ');
    month = month.split(',')[0]

    let stringDate = `${month} ${day}, ${year}`

    const date = new Date(stringDate);
    const unixTimestamp = Math.floor(date.getTime() / 1000);

    return unixTimestamp;
  }

  openStreetAddressModal() {
    this.isModalOpen = true;

    const modalRef = this.modalStreetAddressService.open(this.campaignData, true);
    
    modalRef.onClose.pipe().subscribe((selectedAddress) =>{
      if(selectedAddress != 'close') {
        const addressText = window['utils'].getStreetAddressText(selectedAddress);
      
        this.addressInput.setValue(selectedAddress);
        this.address = addressText;

        if(selectedAddress?.unitNum) {
          this.addressUnit.setValue(selectedAddress.unitNum);
          this.isUnitLabelActive = true;
        }
      }
      this.modalStreetAddressService.modalRef = null;
      this.isModalOpen = false;
    })

  }

  ngAfterViewInit(): void {
    window['$']('.datepicker').pickadate({
      formatSubmit: 'yyyy/mm/dd',
      closeOnSelect: true,
      closeOnClear: false,
      selectYears: true,
      selectMonths: true
    });

  }
  
  onAutocompleteSelected({ address_components, formatted_address }) {
    const { street1, street2, city, zip, state, country } = window['utils'].parseGoogleStreetAddress(address_components)
    const address = this.addressInput;
    const unitNum = this.addressUnit.value;
    address.setValue({
      street1,
      street2,
      city,
      zip,
      state,
      country,
      unitNum: unitNum
    });

    const addressText = window['utils'].getStreetAddressText(address.value);
    this.address = addressText;
  }

  onLocationSelected($event) {
  }

  onClearAddress() {
    this.address = '';
    const address = this.addressInput;
    address.setValue({});
  }

  onBlur() {
    const address = this.addressInput;
    const addressText = window['utils'].getStreetAddressText(address.value);
    this.address = addressText;

    if (this.field) {
      this.field.nativeElement.value = addressText;
    }
  }

  getCheckboxValue() {
    this.isMemoInputLabelActive = !!this.memoInput.value;
    this.showMemo = this.addMemoP2PCheckbox.nativeElement.checked;
  }

  close() {
    this.modalP2pAddDonationsService.close();
  }
}
